var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mass-transfer" },
    [
      _c("div", { staticClass: "container-header" }, [
        _c("div", { staticClass: "container-header__title" }, [
          _vm._v(_vm._s(_vm.i18n.tr_create_mass()))
        ])
      ]),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "container container_40 mass-transfer__card" },
        [
          _c(
            "p",
            { staticClass: "mass-transfer__text-paragraph text_medium" },
            [_vm._v(_vm._s(_vm.i18n.tr_mass_about()))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mass-transfer__link",
              on: {
                click: function($event) {
                  _vm.isHowToOpened = true
                }
              }
            },
            [_vm._v(_vm._s(_vm.i18n.tr_how_to_create_csv()))]
          ),
          _vm._v(" "),
          _c("file-field", {
            staticClass: "mass-transfer__upload-input",
            attrs: { accept: ".csv", id: "preissuance-field" },
            model: {
              value: _vm.documents.transfers,
              callback: function($$v) {
                _vm.$set(_vm.documents, "transfers", $$v)
              },
              expression: "documents.transfers"
            }
          }),
          _vm._v(" "),
          _vm.recipientNotFound
            ? [
                _c("p", { staticClass: "mass-transfer__errors" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.i18n.tr_found_errors()) +
                      ":\n        "
                  ),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.i18n.tr_current_recipient_not_found({
                          recipient: _vm.recipientNotFound
                        })
                      )
                    )
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.transfers.length
            ? [
                _c("div", { staticClass: "mass-transfer__total-wrap" }, [
                  _c(
                    "p",
                    { staticClass: "mass-transfer__total text_medium" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.i18n.tr_total_amount()) +
                          ":\n          "
                      ),
                      _vm._l(_vm.totals.amounts, function(amount, asset, i) {
                        return [
                          Object.keys(_vm.totals.amounts).length > 1
                            ? [_c("br"), _vm._v(_vm._s(i + 1) + ".")]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "mass-transfer__amount" }, [
                            _vm._v(_vm._s(_vm.roundCurrency(amount, asset)))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "mass-transfer__asset" }, [
                            _vm._v(_vm._s(_vm.assetIcon(asset)))
                          ])
                        ]
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "mass-transfer__total text_medium" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.i18n.tr_total_source_fee()) +
                          ":\n          "
                      ),
                      _vm._l(_vm.totals.sourceFees, function(amount, asset, i) {
                        return [
                          Object.keys(_vm.totals.sourceFees).length > 1
                            ? [_c("br"), _vm._v(_vm._s(i + 1) + ".")]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "mass-transfer__amount" }, [
                            _vm._v(_vm._s(_vm.roundCurrency(amount, asset)))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "mass-transfer__asset" }, [
                            _vm._v(_vm._s(_vm.assetIcon(asset)))
                          ])
                        ]
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "mass-transfer__total text_medium" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.i18n.tr_total_recipient_fee()) +
                          ":\n          "
                      ),
                      _vm._l(_vm.totals.destinationFees, function(
                        amount,
                        asset,
                        i
                      ) {
                        return [
                          Object.keys(_vm.totals.destinationFees).length > 1
                            ? [_c("br"), _vm._v(_vm._s(i + 1) + ".")]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "mass-transfer__amount" }, [
                            _vm._v(_vm._s(_vm.roundCurrency(amount, asset)))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "mass-transfer__asset" }, [
                            _vm._v(_vm._s(_vm.assetIcon(asset)))
                          ])
                        ]
                      })
                    ],
                    2
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.transfers.length
            ? [
                _c(
                  "md-table",
                  { staticClass: "mass-transfer__receiver-table text_medium" },
                  [
                    _c(
                      "md-table-row",
                      [
                        _c(
                          "md-table-head",
                          { staticClass: "mass-transfer__table-cell" },
                          [_vm._v(_vm._s(_vm.i18n.lbl_status()))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-head",
                          { staticClass: "mass-transfer__table-cell" },
                          [_vm._v(_vm._s(_vm.i18n.lbl_email()))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-head",
                          { staticClass: "mass-transfer__table-cell" },
                          [_vm._v(_vm._s(_vm.i18n.lbl_amount()))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-head",
                          { staticClass: "mass-transfer__table-cell" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.i18n.lbl_source_fees())
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.i18n.lbl_fixed_percent()) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-head",
                          { staticClass: "mass-transfer__table-cell" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.i18n.lbl_destination_fees())
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.i18n.lbl_fixed_percent()) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.transfers, function(transfer) {
                      return [
                        _c(
                          "md-table-row",
                          [
                            _c(
                              "md-table-cell",
                              {
                                staticClass: "mass-transfer__table-cell",
                                class: {
                                  "mass-transfer__table-cell--error":
                                    transfer.status &&
                                    transfer.status !== "Success"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(transfer.status || "--") +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              { staticClass: "mass-transfer__table-cell" },
                              [_vm._v(_vm._s(transfer.email))]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              { staticClass: "mass-transfer__table-cell" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.roundCurrency(
                                        transfer.amount,
                                        transfer.asset
                                      )
                                    ) +
                                    " " +
                                    _vm._s(_vm.assetIcon(transfer.asset)) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              { staticClass: "mass-transfer__table-cell" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.roundCurrency(
                                        transfer.sourceFees.fixed,
                                        transfer.asset
                                      )
                                    ) +
                                    " / " +
                                    _vm._s(
                                      _vm.roundCurrency(
                                        transfer.sourceFees.percent,
                                        transfer.asset
                                      )
                                    ) +
                                    "\n              " +
                                    _vm._s(
                                      _vm.assetIcon(
                                        transfer.sourceFees.feeAsset
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              { staticClass: "mass-transfer__table-cell" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.roundCurrency(
                                        transfer.destinationFees.fixed,
                                        transfer.asset
                                      )
                                    ) +
                                    " / " +
                                    _vm._s(
                                      _vm.roundCurrency(
                                        transfer.destinationFees.percent,
                                        transfer.asset
                                      )
                                    ) +
                                    "\n              " +
                                    _vm._s(
                                      _vm.assetIcon(
                                        transfer.destinationFees.feeAsset
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    })
                  ],
                  2
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-wrap space-between" },
            [
              _c(
                "md-button",
                {
                  staticClass: "btn md-primary",
                  attrs: { disabled: !_vm.transfers.length || _vm.isPending },
                  on: { click: _vm.submit }
                },
                [_vm._v(_vm._s(_vm.i18n.lbl_confirm_send()) + "\n      ")]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.isHowToOpened },
          on: {
            "update:mdActive": function($event) {
              _vm.isHowToOpened = $event
            },
            "update:md-active": function($event) {
              _vm.isHowToOpened = $event
            }
          }
        },
        [
          _c("div", { staticClass: "text_large mass-transfer__dialog-title" }, [
            _vm._v(_vm._s(_vm.i18n.tr_about_csv()))
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("p", { staticClass: "mass-transfer__dialog-text" }, [
                _vm._v(_vm._s(_vm.i18n.tr_mass_about_detailed()))
              ]),
              _vm._v(" "),
              _c(
                "md-table",
                { staticClass: "mass-transfer__dialog-table text_medium" },
                [
                  _c(
                    "md-table-row",
                    [
                      _c(
                        "md-table-head",
                        { staticClass: "mass-transfer__table-cell" },
                        [
                          _vm._v(
                            _vm._s(_vm.i18n.lbl_recipient_email_or_account())
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-table-head",
                        { staticClass: "mass-transfer__table-cell" },
                        [_vm._v(_vm._s(_vm.i18n.lbl_amount()))]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-table-head",
                        { staticClass: "mass-transfer__table-cell" },
                        [_vm._v(_vm._s(_vm.i18n.lbl_asset()))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-table-row",
                    [
                      _c("md-table-cell", [_vm._v("alice@mail.com")]),
                      _vm._v(" "),
                      _c("md-table-cell", [_vm._v("0.012")]),
                      _vm._v(" "),
                      _c("md-table-cell", [_vm._v("BTC")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-table-row",
                    [
                      _c("md-table-cell", [_vm._v("bob@mail.com")]),
                      _vm._v(" "),
                      _c("md-table-cell", [_vm._v("1.541")]),
                      _vm._v(" "),
                      _c("md-table-cell", [_vm._v("ETH")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-table-row",
                    [
                      _c("md-table-cell", [_vm._v("john@mail.com")]),
                      _vm._v(" "),
                      _c("md-table-cell", [_vm._v("0.998")]),
                      _vm._v(" "),
                      _c("md-table-cell", [_vm._v("ETH")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "mass-transfer__dialog-table text_medium" },
                [_vm._v(_vm._s(_vm.i18n.tr_should_look_like()))]
              ),
              _vm._v(" "),
              _c("blockquote", { staticClass: "mass-transfer__csv-example" }, [
                _vm._v("\n        alice@mail.com,0.012,BTC "),
                _c("br"),
                _vm._v("\n        bob@mail.com,1.541,ETH "),
                _c("br"),
                _vm._v("\n        john@mail.com,0.998,ETH "),
                _c("br")
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "mass-transfer__dialog-table text_medium" },
                [_vm._v(_vm._s(_vm.i18n.tr_use_editor()))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-wrap margin-top" },
            [
              _c(
                "md-button",
                {
                  staticClass: "btn md-primary",
                  on: {
                    click: function($event) {
                      _vm.isHowToOpened = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.i18n.lbl_got_it()))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f0fec13", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f0fec13","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/massTransfers/MassTransfers.Make.vue
// module id = cfda
// module chunks = 1